import React, { useState } from 'react';
import Skeleton from 'react-loading-skeleton';
import { Flexbox } from '../action/Flexbox';
import ThemedText from '../theme/ThemedText';
import './Tags.scss';

const baseColor = 'var(--skeleton-base-color)';
const highlightColor = 'var(--skeleton-highlight-color)';

const TagsSkeleton = ({ count = 4 }) => {
  return (
    <Flexbox className='tags_wrapper' gap='0.75rem'>
      {Array.from({ length: count }).map((_, index) => (
        <div key={`tags_skeleton_${index}`} className='tags_wrapper_chip'>
          <Skeleton width={60 + Math.random() * 40} height={14} baseColor={baseColor} highlightColor={highlightColor} borderRadius={50} />
        </div>
      ))}
    </Flexbox>
  );
};

const Tags = ({ tags, onClick, isLoading }) => {
  const [selectedTag, setSelectedTag] = useState();

  function handleTag(item) {
    if (selectedTag?.id === item?.id) {
      setSelectedTag(null);
      onClick(null);
      return;
    }

    onClick(item);
    setSelectedTag(item);
  }
  if (isLoading) return <TagsSkeleton />;
  if (tags?.length === 0) return <></>;

  return (
    <Flexbox className='tags_wrapper' gap='0.75rem'>
      {tags &&
        tags?.map(item => (
          <div onClick={() => handleTag(item)} className={`tags_wrapper_chip ${item?.id === selectedTag?.id && 'tags_wrapper_active'}`}>
            <ThemedText.H6> {item?.tag}</ThemedText.H6>
          </div>
        ))}
    </Flexbox>
  );
};

export default Tags;
